<template>
    <transition name="modal">
        <div class="modal__mask modaldeclaracoes" v-if="showModalCreate != 0">
            <div class="modal__wrapper">
                <div class="modal__container reset">
                    <div class="content__modal">

                        <div class="inner__modal_docs_pj">
                            <div style="display: flex; justify-content: center; width: 100%;">
                                <img style="width: 40px; height: 47px;" src="@/assets/question.png" />
                            </div>
                            <div style="display: flex; justify-content: center; width: 100%;">
                                <h2>Status da assinatura</h2>
                            </div>

                            <div class="formulario">

                                <div class="resumoForm">
                                    <div class="opcoesForm"
                                        v-if="listaAssinaturas == null || listaAssinaturas.length == 0">
                                        <div class="spinner"></div>
                                    </div>
                                    <div v-if="listaAssinaturas != null && listaAssinaturas.length > 0"
                                        style="width: 100%; max-height: 300px; min-height: 50px; overflow-y: auto;">
                                        <table class="table grid-desktop" style="width: 100%;">
                                            <thead>
                                                <th style="width: 50%">Nome e E-mail</th>
                                                <th style="width: 30%">Status</th>
                                                <th style="width: 20%">Ações</th>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(documentoObj, index) in listaAssinaturas" :key="index">
                                                    <td
                                                        :title="documentoObj.NomeRepresentante + ' - E-mail: ' + documentoObj.EmailRepresentante">
                                                        <span class="destaque">{{
                                                            formatText(documentoObj.NomeRepresentante) }} </span>
                                                        {{ formatText(documentoObj.EmailRepresentante) }}
                                                    </td>
                                                    <td>
                                                        <span>{{ documentoObj.Status }}</span>
                                                    </td>
                                                    <td>
                                                        <div class="widget icons produtos"
                                                            style="display: inline-flex; ">
                                                            
                                                            <button class="btnReenviarEmail"
                                                                style="cursor: pointer; font-size: smaller; border-color: white;"
                                                                v-if="documentoObj.Status == 'Não assinado'"
                                                                @click="reenviarEmail(documentoObj.Guid)">Reenviar
                                                                e-mail</button>


                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>


                                        <div class="grid-mobile"
                                            style="display: none; max-height: 300px; overflow-y: auto;">
                                            <div class="rows__carteiras">
                                                <div class="header__row">
                                                    <div class="widget">
                                                        <p>Nome</p>
                                                    </div>

                                                    <div class="widget">
                                                        <p>E-mail</p>
                                                    </div>

                                                    <div class="widget">
                                                        <p>Status</p>
                                                    </div>


                                                </div>

                                                <div v-for="(documentoObj, index) in listaAssinaturas" :key="index">
                                                    <div class="row__client row__client__mobile"
                                                        v-if="documentoObj.NomeRepresentante">
                                                        <div class="info__client">

                                                            <div class="widget">
                                                                <p class="title__mobile">Nome</p>


                                                                <p>{{ documentoObj.NomeRepresentante }}</p>
                                                            </div>

                                                            <div class="widget">
                                                                <p class="title__mobile">E-mail</p>


                                                                <p>{{ documentoObj.EmailRepresentante }}</p>
                                                            </div>

                                                            <div class="widget">
                                                                <p class="title__mobile">Status</p>
                                                                <p>
                                                                    {{ documentoObj.Status }}
                                                                </p>
                                                            </div>

                                                            <div class="widget icons" style="display: inline-flex">

                                                                <button class="btnReenviarEmail"
                                                                    style="cursor: pointer; font-size: smaller; border-color: white;"
                                                                    v-if="documentoObj.Status == 'Não assinado'"
                                                                    @click="reenviarEmail(documentoObj.Guid)">Reenviar
                                                                    e-mail</button>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>


                                            </div>
                                        </div>

                                    </div>
                                </div>

                            </div>

                            <div class="buttonsAcoes"
                                style="justify-content: center; padding: 15px 0; position: relative; bottom: 0; width: 100%;">
                                <div class="row" style="width: 100%;">
                                    <div class="agrupamento-botoes" style="display: flex; justify-content: center; width: 100%;">
                                        <button class="btnDefault" style="width: 50%;"
                                            @click="closeModal">Voltar</button>
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import { mapGetters } from "vuex";
import api from '@/api/axios';

export default {
    computed: {
        ...mapGetters({
            showModalCreate: 'GET_MODAL_ASSINATURA_STATUS',
            listaAssinaturas: 'GET_LISTA_STATUS_ASSINATURAS',
            user: 'auth/user',
        }),
    },
    data() {
        return {
            aceitoTermos: false,
            erroConfirmar: false,
            requisicaoPendente: false,
            isOpen: false,
        }
    },
    watch: {
        showModalCreate() {
            if (this.showModalCreate != 0)
                this.$store.dispatch("FETCH_PJ_LISTA_STATUS_ASSINATURA", this.showModalCreate);
        }
    },
    methods: {

        toggleDropdown() {
            this.isOpen = !this.isOpen;
        },
        closeModal() {
            this.$store.commit("SET_MODAL_ASSINATURA_STATUS", 0);
        },
        formatText(text) {
            if (!text) return ''; // Se o texto for nulo ou indefinido
            return text.length > 50 ? text.slice(0, 50) + '...' : text; // Limite de 25 caracteres
        },
        async reenviarEmail(guid) {

            var obj = {};
            this.requisicaoPendente = true;

            await api.post(`/declaracao/assinante/email?guidDeclaracaoAssinatura=${guid}`, obj)
                .then((retorno) => {
                    if (retorno.status == 200) {
                        this.$swal({
                            icon: 'success',
                            title: 'Reenviar documento',
                            text: 'Documento foi reenviado por e-mail para assinatura',
                        }).then((result) => {
                            this.requisicaoPendente = false;
                            if (result.value) {
                                this.$store.dispatch('FETCH_CONSULTA_LISTA_DOCUMENTOS_CLIENTE');
                                // this.$store.commit("SET_MODAL_TERMOS_DOCUMENTOS", 0);
                                // this.$store.commit("SET_MODAL_TERMOS_DOCUMENTOS_BLOQUEAR_ACEITE", false);
                                // this.$store.dispatch('FETCH_CONSULTA_LISTA_DOCUMENTOS');
                                // this.$store.dispatch('FETCH_CONSULTA_LISTA_DOCUMENTOS_CLIENTE');
                            }
                        });

                    } else {
                        this.requisicaoPendente = false;
                        this.$swal({
                            icon: 'error',
                            title: 'Oops...',
                            text: `Falha ao enviar e-mail para assinatura`,
                        });
                    }
                })
                .catch((error) => {
                    this.requisicaoPendente = false;

                    this.$swal({
                        icon: 'error',
                        title: 'Falha ao vincular assinantes ao documento',
                        text: `${error.response.data.data[0] != null ? error.response.data.data[0] : error.response.data.descricao}`,
                    });
                });



        }
    },
};
</script>






<style lang="scss" scoped>
@include modal;

@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');

.modal__mask {
    position: fixed;
    z-index: 999;
    top: 0;
    left: 0;
    height: 100%;
    background: rgba(0, 0, 0, 0.7) !important;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: opacity 0.3s ease;
}

    .modal__wrapper {
            width: calc(100%);
            height: calc(100%);
            max-height: calc(100%);
    }

/* Mobile Styles */
@media (max-width: 768px) {
    .grid-mobile {
        display: block !important;
        max-width: 100% !important;
        overflow-x: hidden !important;
        max-height: 50vh !important;
        overflow-y: auto !important;
    }

    .grid-desktop {
        display: none !important;
    }

    .modal__wrapper .modal__container.reset {
        position: relative !important;

        @media (max-width: 768px) {
            width: calc(100% - 90px);
            height: auto !important;
            max-height: 75vh;
            margin: 20px;
            border-radius: 16px;
            box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
            padding: 0px !important;
        }

    }

    .buttonsAcoes {
        margin-top: 10px !important;
        padding-top: 10px !important;
        border-top: 1px solid #eee !important;
    }
}



.subTitle {
    color: #383333;
    ;
    margin-top: -30px;
    margin-bottom: 30px;
    font-size: large;
    font-family: "Work Sans", sans-serif;
    font-weight: 400 !important;
}



.modaldeclaracoes {


    .btnReenviarEmail {
        height: 40px;
        font-family: 'Inter', sans-serif;
        /* Fonte Inter */
        background-color: #00235C;
        color: white;
        font-weight: 600;
        /* Peso da fonte semibold */
        font-size: 10px !important;
        line-height: 20px;
        /* Altura da linha */
        border: 1px solid #00235C;
        /* Borda */
        border-radius: 8px;
        /* Raio de borda */
        width: 120px !important;
        cursor: pointer;
        margin-left: 10px !important;

        @media (max-width: 768px) {
            margin-left: 0px !important;
        }

    }

    img {
        margin-top: 0px !important;
    }

    .modal__wrapper .modal__container.reset {
        width: calc(90% - 40px);
        height: calc(90% - 40px);
        max-height: calc(100% - 40px);
        margin: 20px !important;

        @media (min-width: 769px) {
            position: relative !important;
        }

    }

    .content__modal {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 100%;
        margin-top: 20px;

        .close__modal {
            position: absolute;
            right: 34px;
            top: 30px;
            font-family: "Montserrat";

            @media (max-width: 768px) {
                top: 16px;
                right: 16px;
            }
        }

        h3 {
            margin-bottom: 46px;

            @media (max-width: 768px) {
                font-size: 24px;
                margin-bottom: 20px;
                text-align: center;
                max-width: 280px;
            }
        }
    }

    .inner__modal_docs_pj {
        margin-top: 40px !important;
        width: 90% !important;
        align-content: center;

        @media (max-width: 768px) {
            width: 90% !important;

            .title__mobile {
                margin-top: 0px !important;
            }

        }

        img {
            margin-left: 0px !important;
        }

        .row__client__mobile {
            @media (max-width: 768px) {
                width: 100% !important;
                margin: 0 !important;
                padding: 0 !important;
                box-sizing: border-box !important;

                .info__client {
                    display: flex;
                    flex-direction: column !important;
                    width: 100%;
                    padding: 5px 5px 0px 5px !important;

                    .widget {
                        width: 100% !important;
                        margin-bottom: 0px !important;
                        word-break: break-word !important;

                        p {
                            font-size: 14px !important;
                        }

                        .btnReenviarEmail {
                            width: 100% !important;
                            margin-top: 5px !important;
                            margin-bottom: 5px !important;
                            padding: 5px !important;
                            text-align: center !important;
                        }
                    }
                }
            }
        }


        .formulario {
            margin-top: 20px;
            width: 100%;
            margin-bottom: 10px;
            font-family: 'Inter', sans-serif;
            /* Fonte Inter */
            border: 1px solid #EAECF0;
            border-radius: 8px;
            /* Raio de borda */


            .titleForm {
                background-color: white;
                border-bottom: 1px solid #EAECF0;
                width: 100%;

                .btnBlue {
                    height: 40px;
                    font-family: 'Inter', sans-serif;
                    /* Fonte Inter */
                    background-color: #00235C;
                    color: white;
                    border: 1px solid #00235C;
                    /* Borda */
                    border-radius: 8px;
                    /* Raio de borda */
                    width: 100px;
                    cursor: pointer;

                }

                h3 {
                    margin-left: 20px;
                    color: #101828;
                    font-size: 20px;
                    font-weight: 500;
                    font-family: 'Inter', sans-serif;

                }

                h5 {
                    margin-top: 5px;
                    margin-left: 20px;
                    margin-block-start: 0;
                    color: #667085;
                    font-weight: 500;
                    font-family: 'Inter', sans-serif;
                }


            }

            .resumoForm {
                width: 100%;

                .opcoesForm {
                    display: grid;
                    justify-content: center;
                    align-content: space-between;
                    align-items: center;
                    justify-items: center;
                    padding: 30px 0px 30px 0px;

                    h5 {
                        margin-top: 5px;
                        margin-block-start: 0;
                        color: #667085;
                        font-weight: 500;
                        font-family: 'Inter', sans-serif;
                    }

                    img {
                        height: 48px;
                        width: 48px;

                    }


                    .btnBlue {
                        height: 40px;
                        font-family: 'Inter', sans-serif;
                        /* Fonte Inter */
                        background-color: #00235C;
                        color: white;
                        border: 1px solid #00235C;
                        /* Borda */
                        border-radius: 8px;
                        /* Raio de borda */
                        width: 350px;
                        cursor: pointer;

                    }
                }

            }

        }

        margin-top: 40px !important;
        width: 90% !important;
        align-content: center;

        .custom-dropdown {
            position: relative;
            width: 100%;
            font-family: Arial, sans-serif;
        }

        .dropdown-header {
            padding: 10px;
            background-color: #007bff;
            color: white;
            cursor: pointer;
            border-radius: 4px;
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        .dropdown-header span {
            margin-left: 10px;
        }

        .dropdown-header .rotate {
            transform: rotate(180deg);
        }

        .dropdown-list {
            position: absolute;
            top: 100%;
            left: 0;
            right: 0;
            background-color: white;
            border: 1px solid #ccc;
            max-height: 200px;
            overflow-y: auto;
            z-index: 10;
        }

        .setaDrop {
            color: #FFF;
        }

        .dropdown-item {
            padding: 10px;
            display: flex;
            align-items: center;
        }

        .dropdown-item input {
            margin-right: 10px;
        }

        h2 {
            margin-bottom: 20px !important;
        }

        span {
            color: #667085;
            ;
            font-family: Inter;
            font-size: 14px;
            font-weight: 400;
        }

        .help {
            width: 18px;
            height: 18px;
            cursor: pointer;
            transform: rotate(5deg);
            margin-left: 10px;
        }

        img {
            margin-left: 42%;
        }

    }

}

h3 {
    font-size: 20px;
}

.titleConta {
    font-weight: 800 !important;
    text-transform: uppercase;
}

.btnLogin {
    background-color: #565656 !important;
}

.subTitleCinza {
    width: 52%;
    text-align: center;
    font-weight: 400 !important;
    color: #707070 !important;
    font-family: "Work Sans", sans-serif;
}
</style>
